import { createSlice } from '@reduxjs/toolkit'

const STORED_SETTINGS = storedSettings => {
  const settings = {}

  Object.entries(storedSettings).forEach(([k, v]) => {
    const ls_value = localStorage.getItem(`app.settings.${k}`)

    if (!ls_value) {
      localStorage.setItem(`app.settings.${k}`, v.toString())
      settings[k] = v
    } else {
      settings[k] = ls_value === 'true'
    }
  })

  return settings
}

const getLocale = default_lang => {
  const ls_locale = localStorage.getItem('app.settings.locale')

  if (!ls_locale) {
    localStorage.setItem('app.settings.locale', default_lang)
    return default_lang
  }
  return ls_locale
}

const getIsMobileView = () => {
  // ANTD: md	screen ≥ 768px
  const isMobile = window.innerWidth < 768
  localStorage.setItem('app.settings.isMobileView', isMobile.toString())
  return isMobile
}

const getCompany = () => {
  return localStorage.getItem('app.settings.company')
}

const initialState = {
  isMobileView: getIsMobileView(),
  locale: getLocale('en'),
  company: getCompany(),
  ...STORED_SETTINGS({
    isMobileMenuOpen: false,
    isSiderCollapsed: false,
    antd_darkAlgorithm: true,
  }),
}

const settingsSlice = createSlice({
  name: '_settings',
  initialState,
  reducers: {
    set_setting: (state, action) => {
      const { setting, value } = action.payload
      localStorage.setItem(`app.settings.${setting}`, value)
      state[setting] = value
    },
    toogle_setting: (state, action) => {
      const setting = action.payload
      const value = !state[setting]
      localStorage.setItem(`app.settings.${setting}`, value)
      state[setting] = value
    },
  },
})

export const { set_setting, toogle_setting } = settingsSlice.actions

export default settingsSlice
